import { StringParam, useQueryParams } from 'use-query-params'
import { useTranslation } from 'react-i18next'

import { useBreadcrumbs } from '../../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'

import { useDidMountEffect, useQueryList } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { EmployeesTable } from './EmployeesTable/EmployeesTable'

export function EmployeesContainer() {
  const { workplaceGivingService } = useServices()
  const { t } = useTranslation()

  useBreadcrumbs([
    {
      label: t('breadcrumb.employees')
    }
  ])

  const [queryParams, setQueryParams] = useQueryParams(
    {
      filter: StringParam
    },
    {}
  )

  const [{ data, body, isLoading, errorMessage, totalResults }, { query, nextPage, previousPage, refresh }] =
    useQueryList(workplaceGivingService.getEmployeesList, queryParams)

  useDidMountEffect(() => query(queryParams), [queryParams, query])

  return (
    <EmployeesTable
      data={data}
      isLoading={isLoading}
      totalResults={totalResults}
      volunteeringRewardBudgetEnabled={!!body?.volunteeringRewardBudgetEnabled}
      errorMessage={errorMessage}
      nextPage={nextPage}
      previousPage={previousPage}
      queryParams={queryParams}
      setQueryParams={setQueryParams}
      refresh={refresh}
    />
  )
}
